export default __webpack_public_path__ + "static/media/logo.6e5e2c0c.png";